export default "__VITE_ASSET__d24065a9__"